<template>
  <div class="header-content">
    <!-- 标题部分：独立一行，绝对居中 -->
    <div class="header-title">
      <h1>一德小助手</h1>
    </div>
    
    <!-- 操作区：右对齐 -->
    <div class="header-actions">
      <!-- 已登录用户信息区 -->
      <div v-if="authStore.isLoggedIn" class="user-section">
        <el-dropdown trigger="click" @command="handleCommand" placement="bottom-end">
          <span class="user-dropdown">
            <span class="user-email">{{ authStore.user?.email }}</span>
            
            <!-- 升级为 el-tag 彩色徽章 -->
            <el-tag 
              :type="authStore.roleBadge.type" 
              size="small"
              effect="dark"
              class="role-badge"
            >
              {{ authStore.roleBadge.label }}
            </el-tag>

            <el-icon><ArrowDown /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="profile">
                <el-icon><User /></el-icon>
                我的账户
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <el-icon><SwitchButton /></el-icon>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>

      <!-- 未登录状态兜底 -->
      <el-button v-else type="primary" size="small" @click="goToLogin">
        登录
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ArrowDown, User, SwitchButton } from '@element-plus/icons-vue'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

const authStore = useAuthStore()
const router = useRouter()

const goToLogin = () => {
  router.push('/login')
}

const handleCommand = (command) => {
  if (command === 'logout') {
    authStore.logout()
  } else if (command === 'profile') {
    // 后续跳转到我的账户页面（现在先提示）
    router.push('/account')
    // ElMessage.info('我的账户功能开发中...')   // 可根据需要保留或删除
  }
}
</script>

<style scoped>
.header-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100px;        /* 你已改回 */
  padding: 0 12px;
  background-color: #ffffff;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-title h1 {
  margin: 25px 0 0 0;
  font-size: 25px;      /* 保持你原来的大小 */
  font-weight: 600;
  color: #1f2937;
  text-align: center;
}

.header-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: -10px;      /* 保持你原来的间距 */
}

.user-dropdown {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  color: #606266;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.user-email {
  font-weight: 500;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.role-badge {
  font-size: 13px;
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 12px;
  margin-left: 4px;
}
</style>